<template>
<b-container>
    <b-form style="width: 100%;">
        <b-row class="mt-5">
            <b-col>
                <div class="my-3 p-3 bg-white rounded shadow-sm">
                    <h4 class="border-bottom border-gray pb-2 mb-0">Domestico</h4>
                    <div class="media text-muted pt-3">  
                        <b-row style="width: 100%;">  
                            <b-col>
                                <b-form-group label="Tipo personalizado">
                                    <b-input required></b-input>
                                </b-form-group> 
                                <b-form-group label="Tipo personalizado">
                                    <b-input required></b-input>
                                </b-form-group> 
                            </b-col>
                        </b-row> 
                    </div>
                </div>
            </b-col>
            <b-col>
                <div class="my-3 p-3 bg-white rounded shadow-sm">
                    <h4 class="border-bottom border-gray pb-2 mb-0">Industrial</h4>
                    <div class="media text-muted pt-3"> 
                        <b-row style="width: 100%;"> 
                        </b-row> 
                    </div>
                </div>
            </b-col>
        </b-row> 
    </b-form>
    <b-row>
        <b-col>
            <b-button>Guardar</b-button>
        </b-col>
    </b-row>
</b-container>
</template>

<script>
import axios from "axios";
import * as firebase from "firebase/app";
import "firebase/storage";

// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  data() {
    return {
      isLoading: false,
      checkbox: true,
      products: [],
 
    };
  },
  components: {
    Loading
  },
  created() {
  },
  computed: {
   
  },
  watch: {
   
  },
  methods: {
  }
};
</script>
    

<style>
.form {
    width: 100%;;
}
</style>